/**
 * RN环境类型
 */
export type Env = 'test' | 'stage' | 'prod';

/**
 * 获取运行时环境
 * @returns
 */
export const getRuntimeEnv = (): Env => {
  const host = window.location.host;
  const env = (
    [
      {
        env: 'test',
        host: /^172.27/,
      },
      {
        env: 'test',
        host: /ceshi.securities.eastmoney.com:7438$/,
      },
      {
        env: 'test',
        host: /^localhost/,
      },
      {
        env: 'test',
        host: /61\.129\.116\.181/,
      },
      {
        env: 'stage',
        host: /zqhdplus.eastmoney.com:19000$/,
      },
      {
        env: 'stage',
        host: /zqhd.dfcfs.cn:19000$/,
      },
      {
        env: 'prod',
        host: /zqhdplus.eastmoney.com$/,
      },
      {
        env: 'prod',
        host: /zqhd.dfcfs.cn$/,
      },
      {
        env: 'prod',
        host: /compoffice\.eastmoney\.com$/,
      },
    ] as { host: RegExp; env: Env }[]
  ).find(item => item.host.test(host))?.env;

  return env ?? 'prod';
};
/** 是否内部部署平台-用户访问 */
export const isInnerEnv = (() => {
  const host = window.location.host;
  const innerServiceList = [
    /^172.27/,
    /^10.10/,
    /^61.129.116.181:8803/,
    /compoffice-uat.eastmoney.com$/,
    /compoffice.eastmoney.com$/,
  ];
  return innerServiceList.some(a => a.test(host));
})();

/**
 * 环境配置集合接口
 */
export interface EnvCollection<T = string> {
  /**
   * `测试`环境
   */
  test: T;
  /**
   * `灰度`环境
   */
  stage?: T;
  /**
   * `生产`环境
   */
  prod: T;
}

/**
 * `选择`并`返回`指定环境的配置
 * @param collection 环境配置集合
 * @returns 对应环境的配置值
 */
export const selectEnv = <T>(collection: EnvCollection<T>) => {
  const env = getRuntimeEnv();
  return collection[env];
};
